import Backbone from 'backbone'
import template from './and-or-link-controls.hbs'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'

const AND = 'and'
const OR = 'or'

const AndOrLinkControls = Backbone.View.extend(/** @lends {AndOrLinkControls} */{

	className: 'and-or-link-controls draggable-list-nodrag',

	/**
	 * A control that allows editing the relationship between conditions in a
	 * conjunction. The controls are a labeled toggle indicating either "And"
	 * or "Or" and a button labeled "Link" or "Unlink"
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} [options.state]
	 *
	 * @param {String} [options.state.andOr] either 'and' or 'or'
	 *
	 * @param {Boolean} [options.state.linked=false] indicates whether the conditions
	 * are currently linked. When linked, the button will be labeled "Unlink",
	 * and when the not linked, the button will be labeled "Link"
	 */
	initialize: function(options = {}) {
		this.options = options
		this.linked = this.options.state?.linked ?? false
	},

	render: function() {
		this.$el.html(template())
		this.renderAndOrToggle()
		this.renderLinked()
		return this
	},

	renderAndOrToggle: function() {
		this.andOrToggle = new LabeledToggle({
			name: 'andOr',
			value: this.options.state?.andOr,
			isSmall: true,
			options: [{
				value: 'and',
				label: _.capitalize(i18n.get('common.and'))
			}, {
				value: 'or',
				label: _.capitalize(i18n.get('common.or'))
			}]
		})
		this.$('.and-or-toggle-container').append(this.andOrToggle.el)
		this.andOrToggle.render()
		this.andOrToggle.on('change', val =>
			this.trigger('change:andOr', val, this.andOrToggle.el))
	},

	renderLinked: function() {
		this.setLinkedContent()
		this.$('.linked').on('click', e => {
			this.linked = !this.linked
			this.setLinkedContent()
			this.trigger('change:linked', this.linked, this.$(e.target))
		})
	},

	setLinkedContent: function() {
		let key = this.linked ? 'admin.licenses.usage.unlink' : 'common.link'
		let iconType = this.linked ? 'unlink' : 'link'
		this.$('.linked').html(icon(iconType) + i18n.get(key))
	},

	/**
	 * @param {AND|OR} andOr either 'and' or 'or'
	 */
	setAndOr: function(andOr) {
		this.andOrToggle.val(andOr, { silent: true })
	},

	autoRemove: true

})

export default AndOrLinkControls
export { AND, OR }

AndOrLinkControls.__filename__ = 'components/logic/and-or-link-controls.js'
